import React, { Component } from 'react';
import { connect } from 'react-redux';
import SimulibNavbar from './SimulibNavbar';
import FixedCard from './FixedCard';
import DynamicCard from './DynamicCard';
import FunctionBarChart from './FunctionBarChart';
import FeatureChart from './FeatureDoughNutChart';
import cvScenarioClassLogo from './../../images/cv_scenario_class_icon.png';
import pcScenarioClassLogo from './../../images/pc_scenario_class_icon.png';
import cvCategoryLogo from './../../images/cv_category_icon.png';
import pcCategoryLogo from './../../images/pc_category_icon.png';
import cvLogicalLogo from './../../images/cv_logical_icon.png';
import pcLogicalLogo from './../../images/pc_logical_icon.png';
import cvGeographyLogo from './../../images/cv_geography_icon.png';
import pcGeographyLogo from './../../images/pc_geography_icon.png';
import cvToolsLogo from './../../images/cv_tools_icon.png';
import pcToolsLogo from './../../images/pc_tools_icon.png';
import { getDashboardPageData } from './../UserFunctions';
import { setPassengerState } from './../../actions/scenarioCatalogue/dashboardAction';
import PropTypes from 'prop-types';

class ScenarioCatalogueDashboard extends Component{
    constructor(props){
        super(props)
        this.state = {
            passengerData: {},
            commercialData: {}
        }
        this.logOut = this.logOut.bind(this);
    }

    logOut() {
        localStorage.removeItem('usertoken');
        this.props.history.push('/')
    }

    componentDidMount() {
        getDashboardPageData().then( (response) => {
            if(response.status === 200){
                this.setState( (prevState) => {
                    return{
                        ...prevState,
                        passengerData: response.data.queried_data.passenger_data,
                        commercialData: response.data.queried_data.commercial_data
                    }
                })
                this.props.dispatch(setPassengerState(this.state.passengerData))
            } else {
                console.log("Error occurred while calling getDashboardPageData API")
            }
        })
    }
    // class ScenarioCatalogueDashboard extends Component{
    //     constructor(props){
    //         super(props)
    //         this.state = {
    //             passengerData: {},
    //             commercialData: {}
    //         }
    //         this.logOut = this.logOut.bind(this);
    //     }
    
    //     logOut() {
    //         localStorage.removeItem('usertoken');
    //         this.props.history.push('/')
    //     }
    
    //     componentDidMount() {
    //         getDashboardPageData().then( (response) => {
    //             if(response.status === 200){
    //                 this.setState( (prevState) => {
    //                     return{
    //                         passengerData: response.data.queried_data.passenger_data,
    //                         commercialData: response.data.queried_data.commercial_data
    //                     }
    //                 })
    //                 this.props.dispatch(setPassengerState(this.state.passengerData))
    //             } else {
    //                 console.log("Error occurred while calling getDashboardPageData API")
    //             }
    //         })
    //     }
    
    render() {
        return (
            <div data-test = 'dashboardComponent'>
                <SimulibNavbar
                    passengerData={this.state.passengerData}
                    commercialData={this.state.commercialData}
                    logOut={this.logOut}
                />
                <div className="container-fluid"
                    style={ this.props.type === "passenger" ?
                    { backgroundColor: "#E2E3FF" }
                    : { backgroundColor: "#E0FCAC" } }
                >
                    <div className="row" style={{ paddingTop: "2%" }}>
                        <div className="col-md-3">
                            <FixedCard
                                type={this.props.type}
                                content="Total Scenario"
                                value={this.props.specificData.total_scenarios}
                            />
                        </div>
                        <div className="col-md-3">
                            <FixedCard
                                type={this.props.type}
                                content="Functional Scenario"
                                value={this.props.specificData.functional_scenarios}
                            />
                        </div>
                        <div className="col-md-3">
                            <FixedCard
                                type={this.props.type}
                                content="FUSA Scenario"
                                value={this.props.specificData.fusa_scenarios}
                            />
                        </div>
                        <div className="col-md-3">
                            <FixedCard
                                type={this.props.type}
                                content="SOTIF Scenario"
                                value={this.props.specificData.sotif_scenarios}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ paddingTop: "2%" }}>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-12">
                                    <FunctionBarChart property={this.props}/>
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: "2%" }}>
                                <div className="col-md-12">
                                    <FeatureChart property={this.props}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <DynamicCard
                                        type={this.props.type}
                                        icon={<i className="fas fa-globe mr-2 float-left"
                                        style={this.props.type === "passenger" ? { color: "#D1FE7D" } : { color: "#622AD8" }}></i>}
                                        value={this.props.standards}
                                        property={this.props}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <DynamicCard
                                        type={this.props.type}
                                        icon={this.props.type === "passenger" ?
                                        <img className="float-left" alt="" style={{width: "7%", paddingRight: "1%"}} src={pcScenarioClassLogo}/>
                                        : <img className="float-left" alt="" style={{width: "7%", paddingRight: "1%"}} src={cvScenarioClassLogo}/>}
                                        value={this.props.scenario_classification}
                                        property={this.props}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: "2%" }}>
                                <div className="col-md-6">
                                    <DynamicCard
                                        type={this.props.type}
                                        icon={this.props.type === "passenger" ?
                                        <img className="float-left" alt=""style={{width: "7%", paddingRight: "1%"}} src={pcCategoryLogo}/>
                                        : <img className="float-left" alt=""style={{width: "7%", paddingRight: "1%"}} src={cvCategoryLogo}/>}
                                        value={this.props.category}
                                        property={this.props}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <DynamicCard
                                        type={this.props.type}
                                        icon={this.props.type === "passenger" ?
                                        <img className="float-left" alt="" style={{width: "7%", paddingRight: "1%"}} src={pcLogicalLogo}/>
                                        : <img className="float-left" alt=""style={{width: "7%", paddingRight: "1%"}} src={cvLogicalLogo}/>}
                                        value={this.props.logical_component}
                                        property={this.props}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: "2%" }}>
                                <div className="col-md-6">
                                    <DynamicCard
                                        type={this.props.type}
                                        icon={this.props.type === "passenger" ?
                                        <img className="float-left" alt="" style={{width: "7%", paddingRight: "1%"}} src={pcGeographyLogo}/>
                                        : <img className="float-left" alt=""style={{width: "7%", paddingRight: "1%"}} src={cvGeographyLogo}/>}
                                        value={this.props.geography_applicability}
                                        property={this.props}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <DynamicCard
                                        type={this.props.type}
                                        icon={this.props.type === "passenger" ?
                                        <img className="float-left" alt="" style={{width: "7%", paddingRight: "1%"}} src={pcToolsLogo}/>
                                        : <img className="float-left" alt="" style={{width: "7%", paddingRight: "1%"}} src={cvToolsLogo}/>}
                                        value={this.props.tools}
                                        property={this.props}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
ScenarioCatalogueDashboard.propTypes={
history:PropTypes.string,
dispatch:PropTypes.string,
type:PropTypes.string,
specificData:PropTypes.string,
scenario_classification:PropTypes.string,
category:PropTypes.string,
logical_component:PropTypes.string,
geography_applicability:PropTypes.string,
tools:PropTypes.string,
standards:PropTypes.string,
}
ScenarioCatalogueDashboard.defaultProps= {
history:[],
dispatch:[],
type:[],
specificData:[],
scenario_classification:[],
category:[],
logical_component:[],
geography_applicability:[],
tools:[],
standards:[],
}
const mapStateToProps = (state) => {
    return {
        type: state.toggleState.text,
        specificData: state.toggleState.specificData,
        standards: state.toggleState.standards,
        scenario_classification: state.toggleState.scenario_classification,
        category: state.toggleState.category,
        logical_component: state.toggleState.logical_component,
        geography_applicability: state.toggleState.geography_applicability,
        tools: state.toggleState.tools
    }
}

export default connect(mapStateToProps)(ScenarioCatalogueDashboard);
